// QR display page for the CDIO booth. Loads the pre-generated same-origin
// QR PNG. The PNG lives in frontend/public/booth-qr.png and is copied to
// the build root by CRA. Visit this page from any device and project/print
// it; visitors scan to land on /booth.
//
// The PNG is regenerated by hand if the booth URL ever changes (see
// scripts/generate_booth_qr.py). Doing it as a static asset keeps the
// runtime free of QR-generation deps and complies with the helmet CSP
// (img-src 'self' default).

import React from 'react';

function BoothQrPage() {
  const url = `${window.location.origin}/booth`;
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        background: '#fff',
      }}
    >
      <h2 className="mb-3 text-center">Try the ITP AI Feedback Coach</h2>
      <div className="mb-3 text-center text-muted">
        Scan to try it on your phone
      </div>
      <img
        src="/booth-qr.png"
        alt="QR code linking to the booth demo"
        style={{
          width: 'min(80vw, 480px)',
          height: 'auto',
          imageRendering: 'pixelated',
          border: '8px solid #fff',
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        }}
      />
      <div className="mt-4 text-center">
        <code style={{ fontSize: '1.1rem' }}>{url}</code>
      </div>
      <div className="mt-4 small text-muted text-center" style={{ maxWidth: 480 }}>
        ITP Metrics &middot; 2026 conference demo &middot;
        {' '}
        not connected to a real survey
      </div>
    </div>
  );
}

export default BoothQrPage;
